module.exports = __webpack_public_path__ + "img/diamond-3.28e9c5ae.png";